/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Binding_Access_Link_LabelInputs */



/**
* | output |
* | --- |
* | "Manage who may use this integration" |
*
* @param {Integrations_Binding_Access_Link_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_binding_access_link_label = /** @type {((inputs?: Integrations_Binding_Access_Link_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Binding_Access_Link_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten, wer diese Integration nutzen darf")
	return /** @type {LocalizedString} */ ("Manage who may use this integration")
});